import { Icon } from "@msuite/ui/icons";
import { formatNumber, guardNumber } from "@msuite/utils/numbers";
import type { Nullable } from "@msuite/utils/types";

/** Props Interface */
interface VehicleFuelProps {
	permille: Nullable<number>;
}

export function VehicleFuel({ permille }: VehicleFuelProps) {
	/** Render */
	const percent = guardNumber(permille) / 10;

	/** Render */
	return (
		<div className="w-full v-stack gap-1">
			<div className="h-stack justify-between text-xs">
				<Icon name="Fuel" />
				<p>{formatNumber(percent, "percent")}</p>
			</div>
			<div className="h-1.5 w-full rounded-full relative overflow-hidden bg-primaryGray-200 dark:bg-primaryGray-700">
				<div
					className="absolute inset-0 bg-linear-90/shorter from-emerald-500 via-yellow-500 to-red-500"
					style={{
						clipPath: `inset(0 ${100 - percent}% 0 0)`,
					}}
				/>
			</div>
		</div>
	);
}
